import React, { useState } from 'react';
import { faqList } from './faqData';
import { Plus, X } from 'lucide-react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ width: '100%', maxWidth: '900px', margin: '40px auto', padding: '0 20px', boxSizing: 'border-box' }}>
      <h2 style={{ color: '#fff', fontSize: 'clamp(22px, 3vw, 28px)', fontWeight: '800', textAlign: 'center', marginBottom: '25px' }}>
        Perguntas Frequentes
      </h2>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {faqList.map((item, index) => {
          const isOpen = openIndex === index;
          return (
            <div key={index} style={{ backgroundColor: '#1f1f1f', borderRadius: '4px', overflow: 'hidden', border: '1px solid #333' }}>
              <button
                onClick={() => toggleAccordion(index)}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  backgroundColor: '#2d2d2d',
                  color: '#fff',
                  border: 'none',
                  padding: '18px 20px',
                  fontSize: '16px',
                  fontWeight: '600',
                  textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'background 0.2s'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#383838'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2d2d2d'}
              >
                <span>{item.question}</span>
                {isOpen ? <X size={22} color="#fff" /> : <Plus size={22} color="#fff" />}
              </button>

              {isOpen && (
                <div style={{ padding: '20px', backgroundColor: '#1a1a1a', color: '#ccc', fontSize: '14px', lineHeight: '1.6', borderTop: '1px solid #333' }}>
                  <p style={{ margin: 0 }}>{item.answer}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}